import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';
import { NotificationApiResponse } from '../../api/Notifications';

export class Notification {
  id: number = 0;
  type: string = null;
  unread: boolean = false;
  date: DateTime = DateTime.now();
  metadata: {
    calculation_id?: number;
    from_entity_id?: string;
    to_entity_id?: string;
  } = {};

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: NotificationApiResponse): Notification {
    const notification = new Notification();

    notification.id = apiData.id;
    notification.type = apiData.type;
    notification.unread = apiData.unread;
    notification.date = DateTime.fromISO(apiData.created);
    notification.metadata.calculation_id = apiData.metadata.calculationId;
    notification.metadata.from_entity_id = apiData.metadata.from_entity_id;
    notification.metadata.to_entity_id = apiData.metadata.to_entity_id;

    return notification;
  }

}

